import { useCherreValueLoadable } from '@cherre-frontend/data-fetching';
import { connectorInventoryDemo } from 'src/services/ConnectorDemo/recoil';

export const useConnectorInventoryListDemo = () => {
  const connectors = useCherreValueLoadable(connectorInventoryDemo);

  return {
    data: connectors.contents.data || [],
    loading: false,
    error: false,
  };
};
